import React from 'react';
import Icon from '../../../components/AppIcon';

const MiddleSchoolPathway = ({ formData, errors, onChange, onCheckboxChange }) => {
  const careerInterestOptions = [
    { id: 'sciences', label: 'Sciences et Découvertes', icon: 'Microscope' },
    { id: 'arts', label: 'Arts et Créativité', icon: 'Palette' },
    { id: 'sports', label: 'Sports et Mouvement', icon: 'Trophy' },
    { id: 'technology', label: 'Technologie et Ordinateurs', icon: 'Laptop' },
    { id: 'languages', label: 'Langues et Communication', icon: 'MessageCircle' },
    { id: 'nature', label: 'Nature et Environnement', icon: 'Leaf' },
    { id: 'helping', label: 'Aider les Autres', icon: 'Heart' },
    { id: 'building', label: 'Construire et Créer', icon: 'Hammer' }
  ];

  const activityOptions = [
    { id: 'reading', label: 'Lire des livres' },
    { id: 'drawing', label: 'Dessiner et peindre' },
    { id: 'playing-sports', label: 'Faire du sport' },
    { id: 'video-games', label: 'Jouer aux jeux vidéo' },
    { id: 'music', label: 'Écouter ou faire de la musique' },
    { id: 'experiments', label: 'Faire des expériences' },
    { id: 'friends', label: 'Passer du temps avec des amis' },
    { id: 'nature-walks', label: 'Se promener dans la nature' }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-green-50 border border-green-200 rounded-lg p-6">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
            <Icon name="Sparkles" size={24} color="#FFFFFF" />
          </div>
          <div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Découvre Tes Passions
            </h3>
            <p className="text-sm text-gray-600">
              Dis-nous ce que tu aimes faire pour t'aider à découvrir ton futur métier !
            </p>
          </div>
        </div>
      </div>

      <div>
        <label className="block text-base font-semibold text-gray-900 mb-4">
          Qu'est-ce qui t'intéresse le plus ? <span className="text-red-500">*</span>
        </label>
        <p className="text-sm text-gray-600 mb-4">
          Choisis au moins 2 domaines qui te passionnent
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {careerInterestOptions?.map((interest) => (
            <label
              key={interest?.id}
              className={`flex items-center gap-3 p-4 border-2 rounded-lg cursor-pointer transition-all ${
                formData?.careerInterests?.includes(interest?.id)
                  ? 'border-green-500 bg-green-50' :'border-gray-200 hover:border-green-300'
              }`}
            >
              <input
                type="checkbox"
                checked={formData?.careerInterests?.includes(interest?.id)}
                onChange={(e) => onCheckboxChange('careerInterests', interest?.id, e?.target?.checked)}
                className="w-5 h-5 text-green-500 rounded focus:ring-green-500"
              />
              <Icon name={interest?.icon} size={24} className="text-green-600" />
              <span className="text-sm font-medium text-gray-900">{interest?.label}</span>
            </label>
          ))}
        </div>
        {errors?.careerInterests && (
          <p className="text-sm text-red-500 mt-2">{errors?.careerInterests}</p>
        )}
      </div>

      <div>
        <label className="block text-base font-semibold text-gray-900 mb-4">
          Qu'aimes-tu faire pendant ton temps libre ?
        </label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {activityOptions?.map((activity) => (
            <label
              key={activity?.id}
              className={`flex items-center gap-3 p-3 border rounded-lg cursor-pointer transition-all ${
                formData?.favoriteActivities?.includes(activity?.id)
                  ? 'border-green-500 bg-green-50' :'border-gray-200 hover:border-green-300'
              }`}
            >
              <input
                type="checkbox"
                checked={formData?.favoriteActivities?.includes(activity?.id)}
                onChange={(e) => onCheckboxChange('favoriteActivities', activity?.id, e?.target?.checked)}
                className="w-4 h-4 text-green-500 rounded focus:ring-green-500"
              />
              <span className="text-sm text-gray-900">{activity?.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} className="text-blue-600 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-blue-900 mb-1">
              Pourquoi ces questions ?
            </p>
            <p className="text-xs text-blue-700">
              Tes réponses nous aident à te suggérer des métiers et des filières qui correspondent à tes passions. Tu pourras toujours changer d'avis plus tard !
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiddleSchoolPathway;